import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";

import type { PartyShellPalette } from "../theme/theme";

type Props = {
  categoryNameEn?: string | null;
  categoryNameAr?: string | null;
  languageStartsWithAr: boolean;
  partyPal: PartyShellPalette;
  /** e.g. "Topic" / localized label above the category title */
  topicLabel: string;
};

/** Topic chip shown under the top bar for the whole session. */
export function ImposterOnlineCategoryBanner({
  categoryNameEn,
  categoryNameAr,
  languageStartsWithAr,
  partyPal,
  topicLabel,
}: Props) {
  const primary = languageStartsWithAr ? categoryNameAr : categoryNameEn;
  const secondary = languageStartsWithAr ? categoryNameEn : categoryNameAr;
  if (!primary?.trim()) return null;
  return (
    <Paper
      elevation={0}
      sx={{
        mx: 2.5,
        mt: 1,
        mb: 1.5,
        px: 2,
        py: 1.25,
        borderRadius: 2,
        border: `1.5px solid ${alpha(partyPal.hot, 0.35)}`,
        bgcolor: alpha(partyPal.hot, 0.1),
      }}
    >
      <Typography sx={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.12em", color: partyPal.inkDim, textTransform: "uppercase", mb: 0.35 }}>
        {topicLabel}
      </Typography>
      <Typography sx={{ fontSize: 17, fontWeight: 900, color: partyPal.ink, lineHeight: 1.3, fontFamily: "var(--font-display)" }}>{primary}</Typography>
      {secondary?.trim() && secondary.trim() !== primary.trim() ? (
        <Typography sx={{ fontSize: 14, color: partyPal.inkDim, mt: 0.5 }}>{secondary}</Typography>
      ) : null}
    </Paper>
  );
}
